// Phase 3 — bridge new Angular code back into the AngularJS `UmsApp` module.
//
// Imported by main.ts immediately after './_module' (which defines UmsApp). NOTE: this
// import is hoisted above the require.context loop, so the legacy my-switch.js /
// AdminLayoutService.js were DELETED — otherwise AngularJS last-registration-wins would let
// them clobber these downgrades.
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { MySwitchComponent } from './components/my-switch/my-switch.component';
import { AdminLayoutService } from './admin/admin-layout.service';
// Phase 4: the Access service is downgraded so the 8 legacy ng1 consumers keep using it.
// Access.js / RoleController.js were DELETED (same clobber reasoning as Phase 3 — this runs
// before require.context). Note: RoleListComponent is NOT downgraded — as of Phase 4.1 it is
// a native Angular component state (see ng/role.states.ts), not an ng1 element directive.
import { AccessService } from './sudo/access/access.service';
// Phase 6: the GradeTemplate service is downgraded so the still-ng1 consumers (the edit page
// EditGradeTemplateController + the copy/component modal controllers) keep using it. The legacy
// GradeTemplate.js was DELETED (same clobber reasoning — this runs before require.context).
import { GradeTemplateService } from './sudo/grade-templates/grade-template.service';

declare const angular: any; // ProvidePlugin-injected, same as main.ts

angular
    .module('UmsApp') // single-arg getter — _module.ts must have run first
    .directive('mySwitch', downgradeComponent({ component: MySwitchComponent, inputs: ['enabled'] }) as any)
    .factory('AdminLayoutService', downgradeInjectable(AdminLayoutService) as any)
    .factory('Access', downgradeInjectable(AccessService) as any)
    .factory('GradeTemplate', downgradeInjectable(GradeTemplateService) as any);
